import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../styles/BTU_HEAT_Meter.css";
import { FaFilePdf, FaChevronRight, FaEnvelope } from "react-icons/fa";
import WhatsAppModal from "./WhatsAppModal";

import btuImg from "../assets/btuImg.png";        // ✅ Your BTU Meter Image
import btuPdf from "../assets/BTU Meter_ Heat Meter_Fu tek.pdf";   // ✅ Your BTU PDF File

export default function BTU_HEAT_Meter() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="BTU-wrapper">
      <Header />

      {/* ✅ Hero Banner */}
      <div className="hero-banner-btu">
        <div className="hero-banner-btu-content">
          <h1>BTU / HEAT METER</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>BTU / Heat Meter</span>
          </div>
        </div>
      </div>

      {/* ✅ Content Section */}
      <div className="btu-content">
        <div className="btu-row">
          <img src={btuImg} alt="BTU Meter" className="btu-img" />

          <div className="btu-info">
            <h2>BTU / Heat Meter</h2>
            <ul>
              <li>The flow tube is made of stainless steel by precision casting or welding process.</li>
              <li>The flowmeter is free from obstruction, abrasion and plastic parts.</li>
              <li>Dual-purpose cooling and heating</li>
              <li>Automatic error diagnosis function ensures safe and accurate operation.</li>
            </ul>

            <div className="btu-buttons">
              <a href={btuPdf} target="_blank" rel="noopener noreferrer">
                <button className="download-catalog-btn">
                  <FaFilePdf /> Full Catalog Download
                </button>
              </a>

              <button
                className="request-quote-btn"
                onClick={() => setIsModalOpen(true)}
              >
                <FaEnvelope /> Request a Quote
              </button>
            </div>
          </div>
        </div>

        <WhatsAppModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

        {/* ✅ Specifications Table */}
        <div className="btu-table-container">
          <table className="btu-spec-table">
            <tbody>
  <tr><td>Power Supply</td><td>24 V DC ±20%, 110 V AC ±15%, 240 V AC ±15%</td></tr>

  <tr><td>Velocity</td><td>±32 m/sec (Bidirectional)</td></tr>

  <tr>
    <td>Display</td>
    <td>2 lines, 16 characters, LCD with backlight; flow rate, velocity, energy totalizer</td>
  </tr>

  <tr><td>Dimensions</td><td>178 × 165 × 55 mm</td></tr>

  <tr>
    <td>Measuring Unit</td>
    <td>Meters, Feet, Cubic meters, Liters, Cubic feet, Gallons, etc.</td>
  </tr>

  <tr>
    <td>Energy Measuring Unit</td>
    <td>GJ, KC, KWh, BTU</td>
  </tr>

  <tr>
    <td>Type of Liquid</td>
    <td>All kinds of single uniform liquids capable of conducting sound waves</td>
  </tr>

  <tr><td>Output</td><td>4–20 mA DC / RS485 / Relay Output</td></tr>

  <tr><td>Accuracy</td><td>±1% of reading @ rate &gt; 0.5 m/sec</td></tr>

  <tr><td>Repeatability</td><td>0.2% of Span</td></tr>

  <tr><td>Security</td><td>Keypad lockout, access code enabled</td></tr>

  <tr><td>Suited Temperature (Std.)</td><td>-30℃ to 90℃</td></tr>

  <tr>
    <td>Installation</td>
    <td>Wall mount / Horizontal, inclined or vertical installation</td>
  </tr>

  <tr><td>Temp Range</td><td>4℃ ~ 95℃</td></tr>

  <tr><td>Temperature Difference Range</td><td>(3–70) K, (2–80) K</td></tr>

  <tr><td>Temperature Resolution</td><td>0.01℃</td></tr>

  <tr><td>Thermal Sensor</td><td>PT1000 RTD</td></tr>

  <tr><td>Protection Class</td><td>IP65</td></tr>

  <tr>
    <td>Cable Length</td>
    <td>10 m standard (extendable up to 300 m)</td>
  </tr>
</tbody>

          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
}
